import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import AssignPhleboModal from "./AssignPhleboModal";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import http from "../../../src/Redux/services/http-common.jsx";




const statusTabs = [
  { label: "ASSIGN", value: "ASSIGNED" },
  { label: "UNASSIGN", value: "UNASSIGNED" },
  { label: "COMPLETE", value: "COMPLETED" },
];

function PhleboMain() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [eclinicList, setEclinicList] = useState([]);
  const [labModalVisible, setLabModalVisible] = useState(false);
  const [labTestDetails, setLabTestDetails] = useState([]);
  const [filters, setFilters] = useState({
    phleboName: "",
    orderId: "",
    eClinicName: "",
    phleboMobile:"",
    patientName: "",
  });
  const fetchData = async (status, customFilters = {}, pageNumber = 0) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PHLEBO_BASEURL}patientLabTests`,
        {
          userId: null,
          assignedStatus: status,
          page: pageNumber,
          size: 10,
          ...customFilters,
        }
      );
      setData(response.data?.content || []);
      setTotalRecords(response.data?.totalElements || 0);
      setPage(pageNumber); // ✅ UPDATE STATE
    } catch (err) {
      console.error("Error fetching phlebo data:", err);
    }
  };

  console.log(totalRecords, page, "sdcfvgf")

  useEffect(() => {
    fetchEclinicList();
  }, []);

  const fetchEclinicList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PHLEBO_BASEURL}eclinicList`);
      const list = response.data?.data || [];
      console.log(list, "rdftgh")
      const formatted = list.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      setEclinicList(formatted);
    } catch (error) {
      console.error("Failed to fetch eClinic list:", error);
    }
  };



  useEffect(() => {
    setPage(0);
    setFilters({ phleboName: "", orderId: "", eClinicName: "" });
    setStartDate(null);
    setEndDate(null);
    fetchData(statusTabs[activeIndex].value, {}, 0);
  }, [activeIndex]);

const formatDate = (dateString) => {
  if (!dateString) return "-";

  return new Date(dateString).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Kolkata", // force IST
  });
};


  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSearch = () => {
    const customFilters = {
      phleboName: filters.phleboName || null,
      orderId: filters.orderId || null,
      patientName: filters.patientName || null,
      phleboMobile:filters.phleboMobile || null,
      eClinicId: filters.eClinicName || null,
      phleboMobile: filters.phleboMobile || null,
      eClinicId: filters.eClinicName || null,
      startDate: startDate ? formatLocalDate(startDate) : null,
      endDate: endDate ? formatLocalDate(endDate) : null,
    };
    setPage(0);

    fetchData(statusTabs[activeIndex].value, customFilters, 0);
  };


  const clearFilters = () => {
    const resetFilters = {
      phleboName: "",
      orderId: "",
      phleboMobile: "",
      eClinicName: "",
      patientName: "",
    };
    setFilters(resetFilters);
    setStartDate(null);
    setEndDate(null);
    setPage(0);
    fetchData(statusTabs[activeIndex].value, {}, 0);
  };

  const fetchLabTestDetails = async (orderId) => {
    try {
      const response = await http.get(
        `${process.env.REACT_APP_PHLEBO_BASEURL}order/${orderId}`
      );
      const details = response.data;
      console.log(details, "fcvgbhn")
      setLabTestDetails(details?.[0] || null);

      setLabModalVisible(true);
    } catch (error) {
      console.error("Error fetching lab test details:", error);
    }
  };

  const getCurrentFilters = () => ({
    phleboName: filters.phleboName || null,
    orderId: filters.orderId || null,
    eClinicId: filters.eClinicName || null, // Note: using eClinicId not eClinicName
    phleboMobile: filters.phleboMobile || null,
    patientName: filters.patientName || null,
    startDate: startDate ? formatLocalDate(startDate) : null,
    endDate: endDate ? formatLocalDate(endDate) : null,
  });




  return (
    <div className="p-4">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem", paddingTop: "50px" }}>
        <h2 style={{ fontSize: "1.25rem", fontWeight: "600", margin: 0 }}></h2>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem", fontSize: "14px", fontWeight: "500", color: "#2eaf7d" }}>
          <span
            style={{ cursor: "pointer", textDecoration: "underline", fontSize: "1rem", fontWeight: "600", cursor: "pointer" }}
            onClick={() => navigate("/active-phlebo")}
          >
            Active Phlebo Users
          </span>
          <div style={{ height: "16px", borderLeft: "1px solid #2eaf7d" }} />
          <span
            style={{ cursor: "pointer", textDecoration: "underline", fontSize: "1rem", fontWeight: "600", cursor: "pointer" }}
            onClick={() => navigate("/active-phlebo", { state: { status: "active" } })}

          >
            Inactive Phlebo Users
          </span>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: "1rem",
          alignItems: "flex-end",
        }}
      >
        <InputText
          placeholder="Patient Name"
          value={filters.patientName}
          onChange={(e) => setFilters({ ...filters, patientName: e.target.value })}
          style={{ width: "12rem" }}
        />

        <InputText
          placeholder="Phlebo Name"
          value={filters.phleboName}
          onChange={(e) => setFilters({ ...filters, phleboName: e.target.value })}
          style={{ width: "12rem" }}
        />

        <InputText
          placeholder="Phlebo No."
          value={filters.phleboMobile}
          onChange={(e) => setFilters({ ...filters, phleboMobile: e.target.value })}
          style={{ width: "12rem" }}
        />
        <InputText
          placeholder="Order ID"
          value={filters.orderId}
          onChange={(e) => setFilters({ ...filters, orderId: e.target.value })}
          style={{ width: "12rem" }}
        />
        <Dropdown
          placeholder="Select eClinic"
          value={filters.eClinicName}
          options={eclinicList}
          onChange={(e) => setFilters({ ...filters, eClinicName: e.value })}
          style={{ width: "12rem" }}

        />

        <Calendar
          value={startDate}
          onChange={(e) => setStartDate(e.value)}
          placeholder="Start Date"
          dateFormat="dd-mm-yy"
          style={{ width: "12rem" }}
        />
        <Calendar
          value={endDate}
          onChange={(e) => setEndDate(e.value)}
          placeholder="End Date"
          dateFormat="dd-mm-yy"
          style={{ width: "12rem" }}
        />

        <button
          onClick={handleSearch}
          style={{
            backgroundColor: "#16a34a",
            color: "white",
            padding: "0.5rem 1rem",
            borderRadius: "0.25rem",
            border: "none",
            cursor: "pointer",
          }}
        >
          Search
        </button>

        <button
          onClick={clearFilters}
          style={{
            backgroundColor: "#e5e7eb",
            color: "#374151",
            padding: "0.5rem 1rem",
            borderRadius: "0.25rem",
            border: "1px solid #d1d5db",
            cursor: "pointer",
          }}
        >
          Clear
        </button>
      </div>




      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        {statusTabs.map((tab, idx) => (
          <TabPanel key={idx} header={tab.label}>
            <DataTable
              value={data}
              lazy
              paginator
              rows={10}
              totalRecords={totalRecords}
              first={page * 10}
              onPage={(e) => {
                const filtersPayload = {
                  phleboName: filters.phleboName || null,
                  orderId: filters.orderId || null,
                  phleboMobile: filters.phleboMobile || null,
                  patientName: filters.patientName || null,
                  eClinicId: filters.eClinicName || null,
                  startDate: startDate ? formatLocalDate(startDate) : null,
                  endDate: endDate ? formatLocalDate(endDate) : null,
                };
                fetchData(statusTabs[activeIndex].value, filtersPayload, e.page);
              }}
            >
              <Column field="orderId" header="Order ID" />
              <Column field="patientName" header="Patient Name" />
              <Column field="patientMobile" header="Patient No." />
               <Column field="address" header="Patient Address" />
              <Column field="phleboName" header="Phlebo Name" />
              <Column field="phleboMobile" header="Phlebo No." />
              
              <Column field="eclinicName" header="eClinic Name" />
              <Column field="assignedPhlebo" header="Assigned Phlebo" />
              <Column field="hospitalName" header="Lab Name" />
              <Column
                field="collectionSampleDate"
                header="Collection Date"
                body={(rowData) => formatDate(rowData.collectionSampleDate)}
              />
              <Column field="sourceChannel" header="Source Channel" />
              <Column
                header="View Tests"
                body={(rowData) => (
                  <span
                    className="pi pi-eye"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.2rem",
                      color: "#6366F1",
                    }}
                    title="View Lab Details"
                    onClick={() => fetchLabTestDetails(rowData.orderId)}
                  />
                )}
              />

              {tab.value === "UNASSIGNED" && (
                <Column
                  header="Action"
                  body={(rowData) => (
                    <button
                      style={{
                        backgroundColor: "#3B82F6",
                        color: "white",
                        padding: "0.25rem 0.75rem", // px-3 py-1
                        borderRadius: "0.25rem", // rounded
                        border: "none",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setSelectedOrder(rowData);
                        setShowModal(true);
                      }}
                    >
                      Assign
                    </button>
                  )}
                />
              )}
            </DataTable>
          </TabPanel>
        ))}
      </TabView>

      <AssignPhleboModal
        visible={showModal}
        onHide={() => setShowModal(false)}
        order={selectedOrder}
        onAssigned={() => fetchData("UNASSIGNED")}
      />

      <Dialog
        header="Lab Test Details"
        visible={labModalVisible}
        style={{ width: '50vw' }}
        onHide={() => setLabModalVisible(false)}
      >

        {labTestDetails?.testDetails?.length > 0 ? (
          <DataTable
            value={labTestDetails.testDetails}
            className="p-datatable-sm"
            responsiveLayout="scroll"
          >
            <Column field="labTestCode" header="Test Code" />
            <Column field="labTestName" header="Test Name" />
          </DataTable>
        ) : (
          <p>No lab test details available.</p>
        )}

      </Dialog>
    </div>
  );
}

export default PhleboMain;
